export class CreateContactTypeModel {
  public descricao = ''
}

export class EditContactTypeModel {
  public id = 0
  public descricao = ''
}

export class DeleteContactTypeModel {
  public id = 0
  public descricao = ''
}

export class SearchContactTypeModel {
  public descricao = ''
}

export class CreateContactTypeResponse {
  public response: any
}
export class EditContactTypeResponse {
  public response: any
}
export class DeleteContactTypeResponse {
  public response: any
}
export class PagedContactTypeResponse {
  public response: any
}
